import { Link as MaterialUILink } from '@mui/material'

import scrollToSection from 'utils/scrollIntoView/scrollIntoView'

import { LinkProps } from './BaseLink.types'

import './BaseLink.scss'

const BaseLink: React.FC<LinkProps> = ({ target, children, sx, ...props }): JSX.Element => {
	const handleClick = (event: any) => {
		event.preventDefault()

		if (target) {
			scrollToSection(target)
		}
	}

	return (
		<MaterialUILink className='base-link' sx={sx} onClick={handleClick} {...props}>
			{children}
		</MaterialUILink>
	)
}

export default BaseLink
